import React from 'react';
import { Button } from 'evergreen-ui';

const File = (props) => {
	const {
		name,
		url,
		isImage,
		className,
	} = props;

	return (
		<a
			href={url}
			className="d-block mb-2"
			target="_blank"
			rel="noopener noreferrer"
			download={name || 'Arquivo'}
		>
			{
				isImage
					? (
						<img
							src={url}
							alt="Imagem enviada"
							className={className || 'd-block w-25 mb-2 img-thumbnail'}
						/>
					)
					: (
						<Button
							iconBefore="cloud-download"
							color="info"
							marginRight={16}
							height={48}
						>
							{name}
						</Button>
					)
			}
		</a>
	);
};

export default File;
